export default "__VITE_ASSET__CZji5Kve__"